import React, { useState } from "react";
import { TextField, Button, Container, Typography, Alert } from "@mui/material";
import { styled } from "@mui/system";
import bmiLogo from "../../assets/images/BMIlogo.png"; // Make sure to have the logo file
import { useAuth } from "../../routing/AuthProvider";

const StyledContainer = styled(Container)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "50vh",
  backgroundColor: "#ffffff",
});

const StyledForm = styled("form")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: 400,
  padding: 32,
  borderRadius: 8,
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
});

const StyledButton = styled(Button)({
  marginTop: 16,
  backgroundColor: "#2196f3", // Matching the header blue color
  "&:hover": {
    backgroundColor: "#1976d2",
  },
});

const StyledLogo = styled("img")({
  width: 150,
  marginBottom: 16,
});

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const auth = useAuth();

  // const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const loginData = { username, password };
      auth.loginAction(loginData);
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <StyledContainer>
      <StyledForm onSubmit={handleSubmit}>
        <StyledLogo src={bmiLogo} alt="BMI Connect Logo" />
        <Typography variant="h4" align="center" gutterBottom>
          Login to BMI Connect
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          label="Username"
          variant="outlined"
          margin="normal"
          fullWidth
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          margin="normal"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <StyledButton type="submit" variant="contained" fullWidth>
          Log In
        </StyledButton>
      </StyledForm>
    </StyledContainer>
  );
};

export default LoginPage;
